import { apiClient } from "../lib/api";

export const onboardingApi = {
  listCases: () => apiClient.get("/onboarding/cases"),
  getCase: (caseId) => apiClient.get(`/onboarding/cases/${caseId}`),
  getCaseByEmployee: (employeeId) => apiClient.get(`/onboarding/by-employee/${employeeId}`),
  updateRequirement: (requirementId, payload) => apiClient.patch(`/onboarding/requirements/${requirementId}`, payload),
  evaluateClearance: (caseId) => apiClient.post(`/onboarding/cases/${caseId}/evaluate-clearance`),
  overrideClearance: (caseId, reason) => apiClient.post(`/onboarding/cases/${caseId}/override-clearance`, { reason }),
  getReminderHistory: (caseId) => apiClient.get(`/onboarding/cases/${caseId}/reminders`),
  sendManualReminder: (requirementId) => apiClient.post(`/onboarding/requirements/${requirementId}/send-reminder`),
  runReminderJob: () => apiClient.post("/onboarding/reminders/run"),
};
